import { render, staticRenderFns } from "./PCBConverter65LessSplit.vue?vue&type=template&id=f387bc52&scoped=true&"
import script from "./PCBConverter65LessSplit.vue?vue&type=script&lang=js&"
export * from "./PCBConverter65LessSplit.vue?vue&type=script&lang=js&"
import style0 from "./PCBConverter65LessSplit.vue?vue&type=style&index=0&id=f387bc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f387bc52",
  null
  
)

export default component.exports